module.exports = __webpack_public_path__ + "static/horizon-art-45d4ead31d7fc8bf8bde4331a0334565.png";